export default "__VITE_ASSET__DaBt0XuI__"